export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/greeting_cards_videos.0e4f148.svg";